import type { ReactNode } from "react";

/**
 * A human's message. `user` is the signed-in user's own turn (right-aligned,
 * filled); `participant` is another person in the chat (outlined, sits under
 * their MessageAuthor header).
 */
export function MessageBubble({
  variant,
  author,
  time,
  children,
}: Readonly<{
  variant: "user" | "participant";
  /** Shown above a `user` bubble (e.g. "You"). Participants use MessageAuthor instead. */
  author?: string;
  time?: string;
  children: ReactNode;
}>) {
  if (variant === "participant") {
    return (
      <div className="ml-10 w-fit max-w-[80%] rounded-2xl rounded-tl-md border border-border-subtle bg-surface-primary px-4 py-2.5 text-sm leading-relaxed text-content-primary">
        {children}
      </div>
    );
  }
  return (
    <div className="flex w-full flex-col items-end gap-1">
      {(author || time) && (
        <div className="text-xs text-content-tertiary">
          {author && <span className="font-medium text-content-secondary">{author}</span>}
          {author && time && "  ·  "}
          {time}
        </div>
      )}
      <div className="max-w-[80%] whitespace-pre-wrap rounded-2xl rounded-tr-md bg-surface-secondary px-4 py-2.5 text-sm leading-relaxed text-content-primary">
        {children}
      </div>
    </div>
  );
}
